export default __webpack_public_path__ + "static/media/bubbles.670936f1.mp3";